export default "__VITE_ASSET__jEsPL8$Q__"